/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { MINTER_TABLE } from "../pages/MinterOnboard/graphql/get-minter-table.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { tableData } from "./test-data/users-table";

import { useAsset } from "../pages/SoldAssetsTable/provider"

const MODULE_NAME = "usersTableService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class usersTableService {
    private static instance: usersTableService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): usersTableService {
        if (!usersTableService.instance) {
            usersTableService.instance = new usersTableService(props);
        }
        return usersTableService.instance;
    }

    async getusersTable() {
        const { id } = useAsset();
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            // return tableData;
            if (client) {
                const res = await client.query({
                    query: MINTER_TABLE,
                    variables: {
                        store: id,
                        offset: 0,
                        size: 5000,
                    },
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "getOnboardingTable: ", res?.data?.getOnboardingTable);

                if (res) {
                    console.log("inside res", res?.data?.getOnboardingTable)
                    let _found = {
                        // col:res?.data?.getOnboardingTable?.data?.columnDefs,
                        // // row:[...res?.data?.getOnboardingTable?.data?.rowData,id]
                        // row:res?.data?.getOnboardingTable?.data?.rowData.map((item:any)=>{
                        //     return({
                        //         ...item,
                        //         storeId:id
                        //     })
                        // })
                        gridOptions: tableData?.gridOptions,
                        currentPage: res?.data?.getOnboardingTable?.currentPage,
                        data: {
                            columnDefs: res?.data?.getOnboardingTable?.data?.columnDefs,
                            // row:[...res?.data?.getOnboardingTable?.data?.rowData,id]
                            rowData: res?.data?.getOnboardingTable?.data?.rowData.map((item: any) => {
                                return ({
                                    ...item,
                                })
                            })
                        },
                        pageSize: res?.data?.getOnboardingTable?.pageSize,
                        totalCount: res?.data?.getOnboardingTable?.totalCount,
                        totalPages: res?.data?.getOnboardingTable?.totalPages
                    }
                    console.log("outside res", _found)
                    if (_found) {
                        return _found;
                    }
                }
            }
        } catch (err) { }
    }
}
